// packages/ui/src/ServiceCard.tsx
import React, { forwardRef } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';

export type ServiceCardProps = MotionProps & {
  title: string;
  description: string;
  link: string;
  icon: LucideIcon;  // React.ComponentType<{ className?: string }>;
  className?: string;
};

const ServiceCard = forwardRef<HTMLAnchorElement, ServiceCardProps>(
  ({ title, description, link, icon: Icon, className = '', ...motionProps }, ref) => (
    <motion.a
      ref={ref}
      href={link}
      aria-label={title}
      className={`group block h-full rounded-2xl bg-white
        border border-slate-200 shadow-sm
        hover:shadow-md hover:border-blue-200
        transition-all duration-300 ${className}`}
      whileHover={{ y: -4 }}
      {...motionProps}
    >
      <div className="p-6 flex flex-col items-center text-center space-y-3">

        {/* CONTENEDOR FIJO + CENTRADO ABSOLUTO */}
        <div
          className="
                relative shrink-0 rounded-xl
                bg-blue-50 text-blue-700 shadow-inner
                leading-none
                w-14 h-14
              " aria-hidden="true">
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon className="block h-8 w-8"/>
          </div>
        </div>

        <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
        <p className="text-sm text-slate-600 leading-relaxed">{description}</p>
      </div>
    </motion.a>
  )
);

export default ServiceCard;